import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiQuery } from 'store/query';
import { addParamsToUrl } from 'utils/query';

import {
  Analytics,
  AnalyticsSummary,
  AnalyticsPage,
  GetAnalyticsPageRequest,
  AnalyticsSales,
  AnalyticsProduct,
  AnalyticsEmployee,
  AnalyticsLocation,
  GetAnalyticsRequest,
  AnalyticsPaymentMethod,
  AnalyticsEmployeeDetails,
  GetAnalyticsEmployeeRequest,
} from './types';

const tagTypes = ['analytics'];

export const analyticsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'analyticsApi',
  endpoints: (build) => ({
    get: build.query<Analytics, GetAnalyticsRequest>({
      providesTags: tagTypes,
      query: (query) => ({
        method: 'get',
        url: addParamsToUrl(URL.GET_ANALYTICS, query),
      }),
    }),

    summary: build.query<AnalyticsSummary, GetAnalyticsRequest>({
      providesTags: tagTypes,
      query: (query) => ({
        method: 'get',
        url: addParamsToUrl(URL.GET_ANALYTICS + '/summary', query),
      }),
    }),

    page: build.query<AnalyticsPage, GetAnalyticsPageRequest>({
      keepUnusedDataFor: 0,
      query: (query) => ({
        method: 'get',
        url: addParamsToUrl(URL.GET_ANALYTICS + '/page', query),
      }),
    }),

    employee: build.query<
      AnalyticsEmployeeDetails,
      GetAnalyticsEmployeeRequest
    >({
      keepUnusedDataFor: 1,
      providesTags: tagTypes,
      query: ({ id, ...query }) => ({
        method: 'get',
        url: addParamsToUrl(
          URL.GET_ANALYTICS_EMPLOYEE.replace(':id', String(id)),
          query
        ),
      }),
    }),
  }),
});

export const {
  useGetQuery,
  useSummaryQuery,
  useLazyPageQuery,
  useEmployeeQuery,
} = analyticsApi;
export type {
  AnalyticsSales,
  AnalyticsProduct,
  AnalyticsEmployee,
  AnalyticsLocation,
  AnalyticsPaymentMethod,
  AnalyticsEmployeeDetails,
};

export { tagTypes };
